import React, { useState } from 'react'
import { Link } from 'react-router-dom'

const UserManagementDetail = () => {


    const [mainImage, setMainImage] = useState("images/gallery/2023-tesla.png");
    const [activeIndex, setActiveIndex] = useState(0);

    const changeImage = (index, src) => {
        setActiveIndex(index);
        setMainImage(src);
    };

    return (
        <div>
            &lt;&gt;
            <div className="page-wrapper">
                <div className="page-content">
                    {/*breadcrumb*/}
                    <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">User Management</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item"><Link to="/"><i className="bx bx-home-alt" /></Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">User Management Detail</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <hr />
                    <div className="card p-4">
                        {/* Back Arrow */}
                        <div className="back-arrow-new">
                            <Link to="/user-management"><i className="bx bx-arrow-back" /></Link>
                        </div>
                        {/* Personal Details */}
                        <h6 className="section-heading mb-3">Personal Details</h6>
                        <div className="info-box mb-4 p-4 border rounded shadow-sm">
                            {/* Profile Image Centered */}
                            <div className="row">
                                <div className="col-lg-2">
                                    <div className="text-center mb-4">
                                        <img src="images/avatars/avatar-1.png" className="rounded-circle mb-2 border" width={120} height={120} alt="User" />
                                        <div className="fw-semibold fs-6">John Doe</div>
                                        <small className="text-muted">@johndoe</small>
                                    </div>
                                </div>
                            </div>
                            {/* Personal Details Fields */}
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <label>First Name</label>
                                    <input className="styled-input" defaultValue="John" readOnly />
                                </div>
                                <div className="col-md-6">
                                    <label>Last Name</label>
                                    <input className="styled-input" defaultValue="Doe" readOnly />
                                </div>
                                <div className="col-md-6">
                                    <label>Username</label>
                                    <input className="styled-input" defaultValue="@johndoe" readOnly />
                                </div>
                                <div className="col-md-6">
                                    <label>Email</label>
                                    <input className="styled-input" defaultValue="john.doe@example.com" readOnly />
                                </div>
                                <div className="col-md-6">
                                    <label>Phone Number</label>
                                    <input className="styled-input" defaultValue="(123) 456-7890" readOnly />
                                </div>
                                <div className="col-md-6">
                                    <label>Account Status</label>
                                    <input className="styled-input" defaultValue="Active" readOnly />
                                </div>
                                <div className="col-md-6">
                                    <label>SEE</label>
                                    <input className="styled-input" defaultValue={20} readOnly />
                                </div>
                                <div className="col-md-6">
                                    <label>Horoscope</label>
                                    <input className="styled-input" defaultValue="Libra" readOnly />
                                </div>
                                <div className="col-md-6">
                                    <label>Date of Birth</label>
                                    <input className="styled-input" defaultValue="Oct 21, 1995" readOnly />
                                </div>
                                <div className="col-md-6">
                                    <label>Gender</label>
                                    <input className="styled-input" defaultValue="Male" readOnly />
                                </div>
                            </div>
                        </div>
                        {/* Social Accounts */}
                        <h6 className="section-heading mb-3">Social Accounts</h6>
                        <div className="info-box mb-4 p-4 border rounded shadow-sm">
                            <div className="row g-3">
                                <div className="col-md-3">
                                    <label className="d-flex align-items-center gap-2">
                                        <i className="bx bxl-facebook-circle fs-5" />
                                        Facebook
                                    </label>
                                    <input className="styled-input" defaultValue="https://facebook.com/johndoe" readOnly />
                                </div>
                                <div className="col-md-3">
                                    <label className="d-flex align-items-center gap-2">
                                        <img src="images/icons/twitter.webp" alt className="socail-icon" />
                                        Twitter
                                    </label>
                                    <input className="styled-input" defaultValue="https://twitter.com/johndoe" readOnly />
                                </div>
                                <div className="col-md-3">
                                    <label className="d-flex align-items-center gap-2">
                                        <i className="bx bxl-instagram fs-5" />
                                        Instagram
                                    </label>
                                    <input className="styled-input" defaultValue="https://instagram.com/johndoe" readOnly />
                                </div>
                                <div className="col-md-3">
                                    <label className="d-flex align-items-center gap-2">
                                        <i className="bx bxl-linkedin-square fs-5" />
                                        LinkedIn
                                    </label>
                                    <input className="styled-input" defaultValue="https://linkedin.com/in/johndoe" readOnly />
                                </div>
                            </div>
                        </div>
                        {/* Subscription Plan */}
                        <h6 className="section-heading mb-3">Subscription Plan</h6>
                        <div className="info-box mb-4 p-4 border rounded shadow-sm">
                            <div className="row g-3">
                                <div className="col-md-2">
                                    <label>Plan</label>
                                    <input className="styled-input" defaultValue="Basic" readOnly />
                                </div>
                                <div className="col-md-2">
                                    <label>Purchase Date</label>
                                    <input className="styled-input" defaultValue="Jan 15, 2025" readOnly />
                                </div>
                                <div className="col-md-2">
                                    <label>Expiry Date</label>
                                    <input className="styled-input" defaultValue="Jan 15, 2026" readOnly />
                                </div>
                                <div className="col-md-3">
                                    <label>Amount Paid</label>
                                    <input className="styled-input" defaultValue="$99.00" readOnly />
                                </div>
                                <div className="col-md-3">
                                    <label>Status</label>
                                    <input className="styled-input" defaultValue="Active" readOnly />
                                </div>
                            </div>
                        </div>
                        {/* Blocked Reason */}
                        <h6 className="section-heading mb-3">Blocked Reason</h6>
                        <div className="row">
                            <div className="col-12">
                                <textarea className="styled-input" rows={3} readOnly defaultValue={"Violation of community guidelines due to repeated spam reports.\n            "} />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    )
}

export default UserManagementDetail